import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  padding: 20px 30px 16px 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  border-left: 6px solid #27ae60;
  /* margin-bottom: 20px; */

  button {
    position: absolute;
    right: 10px;
    top: 15px;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
  }
  svg {
    margin: 4px 30px 0 10px;
  }
  div {
    flex: 1;
    p {
      margin-top: 4px;
      font-size: 14px;
      opacity: 0.8;
      line-height: 20px;
    }
  }
  background: #e5f7e7;
  color: #27ae60;
`
